import { render, staticRenderFns } from "./LivenessCheck.vue?vue&type=template&id=0310bdc7"
import script from "./LivenessCheck.vue?vue&type=script&lang=js"
export * from "./LivenessCheck.vue?vue&type=script&lang=js"
import style0 from "./LivenessCheck.vue?vue&type=style&index=0&id=0310bdc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports